package com.swetdot.swetgram.data

import kotlinx.coroutines.CoroutineDispatcher
import kotlinx.coroutines.Dispatchers

// Browser SQLite runs synchronously on the JS event loop.
actual val ioDispatcher: CoroutineDispatcher = Dispatchers.Default
